import { Link } from "react-router-dom";
import styled from "styled-components";
import { cPath } from "../../constants";
import { normalizeStoreLogoUrl } from "../../utils/storeLogo";

const Section = styled.section`
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid hsl(${({ theme }) => theme.colors.border});
`;

const Title = styled.h2`
  margin: 0 0 1rem;
  font-size: 1.125rem;
  font-weight: 700;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 0.75rem;
`;

const Card = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 0.75rem;
  border-radius: ${({ theme }) => theme.radius.lg};
  border: 1px solid hsl(${({ theme }) => theme.colors.border});
  background: hsl(${({ theme }) => theme.colors.card});
  font-size: 0.875rem;
  font-weight: 600;
  color: hsl(${({ theme }) => theme.colors.foreground});
  &:hover {
    border-color: hsl(${({ theme }) => theme.colors.primary} / 0.4);
  }
`;

const Logo = styled.img`
  width: 2rem;
  height: 2rem;
  object-fit: contain;
  border-radius: 0.25rem;
`;

export default function RelatedStoresStrip({ title = "Related stores", stores = [], excludeSlug }) {
  const items = stores
    .filter((s) => s.slug && s.slug !== excludeSlug)
    .slice(0, 8);
  if (!items.length) return null;

  return (
    <Section>
      <Title>{title}</Title>
      <Grid>
        {items.map((store) => (
          <Card key={store.slug} to={cPath(`store/${store.slug}`)}>
            {store.logo ? (
              <Logo src={normalizeStoreLogoUrl(store.logo)} alt="" loading="lazy" />
            ) : null}
            <span>{store.name}</span>
          </Card>
        ))}
      </Grid>
    </Section>
  );
}
